import { React, useState, useEffect } from 'react';
import { useTeamsSignoffQuery } from '../../../../../../../features/teams/teamsApiSlice';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { toast } from 'sonner';
import { useUpdateOfferLetterMutation, useListOfferTemplateQuery } from '../../../../../../../features/hiringstages/offerApiSlice';

const OfferLetter = ({ canddetails, toggleOffer }) => {
  const [selectedDescription, setSelectedDescription] = useState('');

  const [offerletterSubmit, { isLoading: offerLetterLoading }] =
    useUpdateOfferLetterMutation();

  const {
    data: listOfferTemp,
    isLoading: listOfferTempLoading,
    isSuccess: listOfferTempSuccess,
  } = useListOfferTemplateQuery
      ({ refetchOnMountOrArgChange: true });

  console.log(listOfferTemp)

  const {
    data: usersSignoff,
    isLoading: userSignoffLoading,
    isSuccess: userSignoffSuccess,
  } = useTeamsSignoffQuery({ refetchOnMountOrArgChange: true });

  const canddetailsObj = canddetails?.data;
  const usersSignoffObj = usersSignoff?.data;
  const listOfferTempObj = listOfferTemp?.data;

  console.log(canddetailsObj)
  console.log(listOfferTempObj)

  const initialValues = {
    profile_id: canddetailsObj?.id || '',
    offer_letter_template: localStorage.getItem("selectedTemplateId") || canddetailsObj?.offer_letter_template || '',
    offer_letter: selectedDescription || '',
    offer_sign_required: 2,
    offer_sign_user_id: canddetailsObj?.offer_sign_user_id || '',
    offer_status: 0 //submit offer approved
  };
  useEffect(() => {
    const savedTemplateId = localStorage.getItem("selectedTemplateId");
    console.log(savedTemplateId)
    if (savedTemplateId) {
      formik.setFieldValue("offer_letter_template", savedTemplateId);
    }
  }, []);
  const validationSchema = yup.object({
    offer_letter_template: yup
      .string()
      .required('Please select offer template'),
    offer_sign_user_id: yup.string().required('Please select signoff user'),
  });

  // Function to replace placeholders with actual values
  const replacePlaceholders = (template, canddetailsObj) => {
    console.log(template)
    console.log(canddetailsObj)
    return template
      .replace(/\["Candidate Name"\]/g, `<strong>${canddetailsObj.fullName}</strong>`)
      .replace(/\["Designation"\]/g, `<strong>${canddetailsObj.negotiated_designation}</strong>`)
      .replace(/\["Salary"\]/g, `<strong>${canddetailsObj.negotiated_salary}</strong>`)
      .replace(/\["Joining Date"\]/g, `<strong>${canddetailsObj.negotiated_doj}</strong>`)
  };

  const onSubmit = async (validationSchema) => {
    // console.log(validationSchema)
    // Replace placeholders before submitting
    const updatedOfferLetter = replacePlaceholders(validationSchema.offer_letter, canddetailsObj);
    console.log(updatedOfferLetter)
    // Add updated offer letter to values
    const finalValues = {
      ...validationSchema,
      offer_letter: updatedOfferLetter,
    };

    // console.log('Final values to submit:', finalValues);
    try {
      const rrrr = await offerletterSubmit(finalValues).unwrap();
      toast.success('Data Add Successfully');
      toggleOffer('offerlist', 'offer')
    } catch (error) { }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true,
  });


  // In your Formik setup
  const handleTemplateChange = (e) => {
    const selectedTemplateId = parseInt(e.target.value, 10);
    localStorage.setItem("selectedTemplateId", selectedTemplateId);
    formik.handleChange(e); // Make sure to call Formik's handler too
    // Find the selected template by ID and set its description
    const selectedTemplate = listOfferTempObj.find(
      (template) => template.id === selectedTemplateId
    );
    if (selectedTemplate) {
      setSelectedDescription(
        selectedTemplate.description.replace(/\n/g, "<br/>") // Convert new lines to <br/>
      );
    }
  };
  const offerStatus = (negotationStatusId, offerStatusId, offerApproveStatusId, candStatus) => {
    console.log(negotationStatusId, offerApproveStatusId, offerStatusId, candStatus)
    if (offerStatusId == 0 || offerStatusId == null)
      return (
        <span className="bg-gray-400 block rounded-md px-3 py- text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-0">
          Yet to Accept
        </span>
      );
    if (negotationStatusId == 2 && offerApproveStatusId == 1 && candStatus === 1) {
      return (
        <span className="bg-green-700 block rounded-md px-3 py- text-center text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-0">
          Candidate Approved Offer
        </span>
      );
    } else if (negotationStatusId === 2 && offerApproveStatusId == 1) {
      return (
        <span className="bg-yellow-600 block rounded-md px-3 py- text-center text-sm font-semibold text-white shadow-sm hover:bg-yellow-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-0">
          Waiting for Candidate Approved
        </span>
      );
    } else if (negotationStatusId === 2 && offerStatusId == 1) {
      return (
        <span className="bg-blue-700 block rounded-md px-3 py- text-center text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-0">
          Submitted for Approval- Offer
        </span>
      );
    } else if (negotationStatusId === 3 || offerApproveStatusId == 2) {
      return (
        <span className="bg-red-600 block rounded-md px-3 py- text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-0">
          Candidate Rejected Offer
        </span>
      );
    } else if (negotationStatusId === 4 || offerApproveStatusId == 3) {
      return (
        <span className="bg-purple-600 block rounded-md px-3 py- text-center text-sm font-semibold text-white shadow-sm hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-0">
          Offer Query
        </span>
      );
    }
  };
  // const offerStatus = (statusVal) => {
  //   if (statusVal === 1) {
  //     return (
  //       <div className="bg-green-700 px-6 py-2 text-white block w-full text-center">
  //         Offer Accepted{' '}
  //       </div>
  //     );
  //   } else if (statusVal === 2) {
  //     return (
  //       <div className="bg-red-600 px-3 py-2 text-white block w-full text-center">
  //         Offer Rejected{' '}
  //       </div>
  //     );
  //   } else if (statusVal === 3) {
  //     return (
  //       <div className="bg-blue-600 px-3 py-2 text-white block w-full text-center">
  //         Offer Query
  //       </div>
  //     );
  //   }
  // };

  return (
    <form className=" bg-white pb-4 rounded-lg" onSubmit={formik.handleSubmit}>
      {/* {offerStatus
        (canddetailsObj?.negotiation_approval_status,
          canddetailsObj?.offer_status,
          canddetailsObj?.offer_approval_status,
          canddetailsObj?.candidate_approval_status
        )
      } */}
      <div className=" bg-gray-200 py-4 rounded-lg px-4">
        <div className="rounded-md shadow-3xl mx-0">
          {' '}
          <div className="flex flex-row mt-0">
            <div className="gap-4 rounded-lg mr-0">
              {' '}
              <div className=" bg-gray-200 pb-4 rounded-lg">
                <div className="pt-3 px-2">
                  <select
                    name="offer_letter_template"
                    id="offer_letter_template"
                    // autoComplete="offer_letter_template"
                    placeholder=""
                    onChange={handleTemplateChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.offer_letter_template}
                    className="bg-white border border-inputBorder mt-1 ml-2 block w-64 rounded-md py-2 px-3 focus:border-purplecolor-100 focus:outline-none sm:text-sm"
                  >
                    {/* <option value={''}>Choose Offer Template</option>
                  <option value={1}> Offer Template 1</option>
                  <option value={2}>Offer Template 2</option> */}
                    <option value="">Choose Offer Template</option>
                    {/* Check if data is successfully loaded and then map through the list */}
                    {listOfferTempObj?.map((OffTemp) => (
                      // {listOfferTempSuccess && listOfferTemp?.data && (
                      <option key={OffTemp.id} value={OffTemp.id}>
                        {OffTemp.template_title}
                      </option>
                    ))}
                  </select>

                  {formik.touched.offer_letter_template &&
                    formik.errors.offer_letter_template ? (
                    <div className="mt-2 text-sm text-red-600">
                      {formik.errors.offer_letter_template}
                    </div>
                  ) : null}
                </div>
                {/* Display the selected template description */}
                <div className="bg-white rounded-md py-4 px-4 mx-4 my-4">
                  {selectedDescription && (
                    <div
                      dangerouslySetInnerHTML={{ __html: selectedDescription }}
                    />
                  )}
                </div>
                {/* <div dangerouslySetInnerHTML={{ __html: desc }} className="bg-white rounded-md py-4 px-4 mx-4 my-4" /> */}

                {/* <div className="bg-white rounded-md py-4 px-4 mx-4 my-4">
                <span className="flex">
                  Dear
                  <p className="text-sidebar pl-1">[Candidate Name]</p>
                </span>
                <p className="py-2">
                  Wipro is delighted to offer you the full-time position of
                  <e className="text-sidebar pl-1">[Designation]</e>
                  with an anticipated start date of
                  <e className="text-sidebar pl-1">[Joining date],</e>
                  contingent upon [background check, drug screening, etc.].{' '}
                </p>

                <p>
                  As the
                  <e className="text-sidebar pl-1">[Designation]</e>, you will
                  be responsible for [brief mention of job responsibilities and
                  expectations].{' '}
                </p>

                <p className="py-2">
                  You will report directly to [manager/supervisor name and
                  title] at [workplace location]. Working hours are from [hours
                  of day, days of week].
                </p>

                <p>
                  The starting salary for this position is{' '}
                  <e className="text-sidebar pl-1">[Salary]</e>
                  per month. Payment is on a monthly basis by [direct deposit,
                  check, etc.]. In addition, you will be eli gible to receive
                  [discuss additional compensation potential].
                </p>

                <p className="py-2">
                  {' '}
                  Wipro offers a comprehensive benefits program, which includes
                  [medical insurance, 401(k), paid time off, etc.].{' '}
                </p>

                <p>
                  Your employment with Wipro will be on an at-will basis, which
                  means you and the company are free to terminate employment at
                  any time, with or without cause or advance notice. This letter
                  is not a contract indicating employment terms or duration.
                </p>

                <p className="py-2">
                  Please confirm your acceptance of this offer by signing and
                  returning this letter by [offer expiration date].
                </p>

                <p className="text-md font-semibold">Sincerely,</p>
                <p className="text-sidebar mt-4">[Signature]</p>
              </div> */}
                {/* <div className="flex h-6 items-center pl-5 py-4">
                <input
                  id="add_digital_signature"
                  aria-describedby="add_digital_signature"
                  name="add_digital_signature"
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer"
                  checked={isRecommendChecked}
                  onChange={() =>
                    setIsRecommendChecked(!isRecommendChecked)
                  }
                />
                <div className="ml-3 text-md leading-6">
                  <label
                    htmlFor="add_digital_signature"
                    className="font-semibold cursor-pointer"
                  >
                    Add Digital Signature
                  </label>
                </div>
              </div> */}

                <div className="flex justify-between">
                  <div>
                    <div className="pt-3 px-2">
                      <select
                        name="offer_sign_user_id"
                        id="offer_sign_user_id"
                        className="bg-white border border-inputBorder mt-1 ml-2 block w-64 rounded-md  py-2 px-3  focus:border-purplecolor-100 focus:outline-none sm:text-sm"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.offer_sign_user_id}
                      >
                        <option value="">Choose Authorized Person</option>
                        {usersSignoffObj?.map((SFUser) => (
                          <option key={SFUser?.id} value={SFUser?.id}>
                            {SFUser?.first_name} {SFUser?.last_name}
                          </option>
                        ))}
                      </select>

                      {formik.touched.offer_sign_user_id &&
                        formik.errors.offer_sign_user_id ? (
                        <div className="mt-2 text-sm text-red-600">
                          {formik.errors.offer_sign_user_id}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="flex self-center">
                    <div className=" ">
                      <button
                        type="submit"
                        className="inline-flex justify-center rounded-3xl border border-transparent bg-green-900 py-3 px-8  mr-4 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:outline-none"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default OfferLetter;
